import axios from "axios";
import type { DashboardWidget } from "../../types/dashboard/dashboard.types";

const backendUrl =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

// Instance Axios unique
const axiosInstance = axios.create({
  baseURL: `${backendUrl}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Intercepteur token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/* ===========================
   FETCH WIDGETS
=========================== */
export const fetchDashboardWidgets = async (
  id_dashboard: number
): Promise<DashboardWidget[]> => {
  try {
    const response = await axiosInstance.get(
      `/dashboard/${id_dashboard}/widgets`
    );

    // 🔒 Sécurité : toujours retourner un tableau
    return Array.isArray(response.data?.Dashboards)
      ? response.data.Dashboards
      : [];
  } catch (error) {
    console.error("Erreur fetchDashboardWidgets:", error);
    return [];
  }
};

/* ===========================
   ADD WIDGET
=========================== */
export const addWidget = async (
  widget: Omit<DashboardWidget, "id">
): Promise<{ id_widget: number }> => {
  try {
    const response = await axiosInstance.post("/dashboard/add", widget);
    return response.data;
  } catch (error) {
    console.error("Erreur addWidget:", error);
    throw error;
  }
};

/* ===========================
   UPDATE DASHBOARD
=========================== */
export const updateDashboard = async (
  widgets: Array<{
    id_widget: number;
    content: string;
    type: string;
    x: number;
    y: number;
    w: number;
    h: number;
  }>
): Promise<{ message: string }> => {
  const response = await axiosInstance.put("/dashboard/update", { widgets });
  return response.data;
};


/* ===========================
   DELETE WIDGET
=========================== */
export const deleteWidget = async (
  id_widget: string | number
): Promise<{ message: string }> => {
  try {
    const response = await axiosInstance.delete(
      `/dashboard/delete/${String(id_widget)}`
    );
    return response.data;
  } catch (error) {
    console.error("Erreur deleteWidget:", error);
    throw error;
  }
};


export default axiosInstance;
